import { ComponentProps } from "react";
import { Progress, Tooltip, theme } from "antd";

const progressStyle: React.CSSProperties = { width: "100px", height: "24px" };

// Use theme tokens for colors
const getProgressColors = (token: any) => ({
  success: token.colorSuccess,
  warning: token.colorWarning,
  error: token.colorError,
  neutral: token.colorTextSecondary,
});

const buckets: { [key: string]: string } = {
  "0": "success",
  "10": "success",
  "20": "success",
  "30": "success",
  "40": "success",
  "50": "warning",
  "60": "warning",
  "70": "warning",
  "80": "error",
  "90": "error",
  "100": "error",
};

export const ProgressBar = ({
  type = "neutral",
  naComponent = <>N/A</>,
  ...props
}: {
  key: string;
  value: string;
  total?: number;
  showValue?: boolean;
  type?: "lowerBetter" | "higherBetter" | "neutral";
  tooltip?: ComponentProps<typeof Tooltip>;
  progress?: Partial<ComponentProps<typeof Progress>>;
  naComponent?: JSX.Element;
}) => {
  const { token } = theme.useToken();
  const colors = getProgressColors(token);

  if (props.value === undefined) return naComponent;
  const total = props.total || 10;
  const percent: number = Math.ceil((Number(props.value) / total) * 100);
  const size = props.progress?.size || "small";
  return (
    <div style={progressStyle}>
      <Tooltip
        placement={props.tooltip?.placement}
        title={
          <>
            <strong>{`${props.value} / ${total}`}</strong>
            {props.tooltip?.title && (
              <>
                <br />
                {props.tooltip.title}
              </>
            )}
          </>
        }
      >
        <Progress
          showInfo={false}
          key={props.key}
          percent={percent}
          strokeColor={colorPercent(type, percent, colors)}
          format={() => total}
          size={size}
          {...props.progress}
        />
      </Tooltip>
    </div>
  );
};

const colorPercent = (
  type: string,
  percent: number,
  colors: Record<string, string>
) => {
  if (type === "neutral") {
    return colors.neutral;
  }
  if (type === "lowerBetter") {
    return colors[buckets[percent]];
  }
  if (type === "higherBetter") {
    return colors[buckets[100 - percent]];
  }
};
